'use client';

import {
  Popover as PopoverRoot,
  type PopoverProps,
  type PopoverBaseProps,
} from './Popover';
import {
  PopoverClose,
  type PopoverCloseProps,
  type PopoverCloseBaseProps,
} from './PopoverClose';
import {
  PopoverPopup,
  type PopoverPopupProps,
  type PopoverPopupBaseProps,
  popoverPopupClasses,
} from './PopoverPopup';
import {
  PopoverTrigger,
  type PopoverTriggerProps,
  type PopoverTriggerBaseProps,
} from './PopoverTrigger';

const Popover = Object.assign(PopoverRoot, {
  Trigger: PopoverTrigger,
  Popup: PopoverPopup,
  Close: PopoverClose,
});

export {
  Popover,
  type PopoverProps,
  type PopoverBaseProps,
  type PopoverTriggerProps,
  type PopoverTriggerBaseProps,
  type PopoverPopupProps,
  type PopoverPopupBaseProps,
  type PopoverCloseProps,
  type PopoverCloseBaseProps,
  popoverPopupClasses,
};
